<template>
  <div class="order-detail">
    <p class="title-p">{{ $t('查看订单详情') }}</p>
    <ul>
      <li v-for="(item, index) in orderDetail" :key="index">
        <div v-if="item.type === 0" class="text">
          <p class="left">
            {{ item.key }}
          </p>
          <p class="right">
            <RichText
              v-for="(item2, index2) in item.value"
              :key="index2"
              :text="item2"
            >
            </RichText>
          </p>
        </div>
        <div v-if="item.type === 1" class="text-line"></div>
      </li>
    </ul>
  </div>
</template>

<script>
import RichText from '@/components/RichText';
export default {
  name: 'OrderDetailCard',
  props: {
    orderDetail: {
      type: Array,
      default: () => [],
    },
  },
  components: {
    RichText,
  },
  data() {
    return {};
  },
  mounted() {},
  methods: {},
};
</script>
<style lang="scss">
.order-detail {
  .right {
    .line {
      img {
        vertical-align: middle;
        position: relative;
        top: -1px;
        margin-right: 2px;
      }
    }
  }
}
</style>
<style lang="scss" scoped>
.order-detail {
  border-radius: 6px;
  background: #fff;
  box-sizing: border-box;
  padding: 20px 20px 1px 20px;
  color: #000;
  .title-p {
    font-family: 'Aspira Medium';
    font-weight: 500;
    font-size: 16px;
    margin-bottom: 18px;
  }
  ul {
    li {
      margin: 20px 0;
      .text {
        display: flex;
        justify-content: space-between;
        align-items: flex-start;
        .left {
          font-family: 'Aspira Light';
          font-size: 16px;
          min-width: 118px;
          line-height: 20px;
          max-width: 34%;
          font-weight: 200;
        }
        .right {
          font-family: 'Aspira Medium';
          font-weight: 500;
          font-size: 16px;
          text-align: right;
          line-height: 20px;
          max-width: 62%;
          .line {
            img {
              width: 30px;
              height: 18px;
            }
          }
        }
      }
      .text-line {
        width: 100%;
        height: 1px;
        margin: 20px 0;
        background: #e5e5e5;
      }
    }
  }
}
@media screen and (max-width: 768px) {
  .order-detail {
    border-radius: rem(12);
    padding: rem(40) rem(24) rem(20) rem(24);
    .title-p {
      font-size: rem(36);
      margin-bottom: rem(36);
    }
    h2 {
      font-size: rem(32);
      margin-bottom: rem(36);
    }
    ul {
      li {
        margin: rem(18) 0;
        .text {
          .left {
            font-size: rem(32);
            min-width: rem(236);
            line-height: rem(40);
          }
          .right {
            flex: 1;
            max-width: rem(426);
            font-size: rem(32);
            line-height: rem(40);
            span {
              display: inline-block;
              max-width: rem(426);
            }
          }
        }
        .text-line {
          height: rem(2);
          margin: rem(36) 0;
        }
      }
    }
  }
}
</style>
